import { Image } from '@tribeplatform/react-components/common/components'
import { T } from '@tribeplatform/react-components/i18n'
import { useColorScheme } from '@tribeplatform/react-ui-kit/ThemeProvider'

const CPO_NAME = 'Ami Asadi'

export const TrialMessagePanel = () => {
  const { colorSchemeMode } = useColorScheme()
  const isLightMode = colorSchemeMode === 'light'
  const bettermodeLogoSrc = isLightMode
    ? '/images/powered-by-bettermode.png'
    : '/images/powered-by-bettermode-on-dark.png'

  return (
    <div className="flex flex-col items-start gap-8 text-start">
      <div className="space-y-8">
        <Image src={bettermodeLogoSrc} className="h-5" />

        <div className="space-y-6">
          <h1 className="text-[2.5rem] font-semibold leading-[1.02] tracking-[-0.04em] text-content lg:max-w-[260px]">
            <T
              defaultMessage="Your trial is complete — it's time to launch"
              id="Admin.Billing.TrialExpired.Title"
            />
          </h1>

          <div className="space-y-5 text-[15px] leading-7 text-content-subdued lg:max-w-[275px]">
            <p>
              <T
                defaultMessage="Over the past 14 days, you explored Bettermode and set up your community."
                id="Admin.Billing.TrialExpired.Body1"
              />
            </p>
            <p>
              <T
                defaultMessage="To publish your community and go live, choose a plan that fits your needs."
                id="Admin.Billing.TrialExpired.Body2"
              />
            </p>
            <p>
              <T
                defaultMessage="Once you subscribe, your community will be visible to members and ready to grow."
                id="Admin.Billing.TrialExpired.Body3"
              />
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-1">
        <p className="font-serif text-[1.75rem] italic leading-none text-content">
          {CPO_NAME}
        </p>
        <p className="text-xs font-medium uppercase tracking-[0.08em] text-content-subdued">
          <T
            defaultMessage="CPO at Bettermode"
            id="Admin.Billing.TrialExpired.SignatureRole"
          />
        </p>
      </div>
    </div>
  )
}
